import { useState } from 'react';
import { IconDownload } from '@tabler/icons-react';
import { ActionIcon } from '@mantine/core';
import { downloadFileFromUrl } from '@/src/shared/utils/download-file';

interface IChatAttachmentImageDownloadButtonProps {
  imageUrl: string;
}

export default function ChatAttachmentImageDownloadButton({
  imageUrl,
}: IChatAttachmentImageDownloadButtonProps) {
  const [isDownloading, setIsDownloading] = useState<boolean>(false);

  const downloadImage = async () => {
    if (isDownloading) {
      return;
    }

    setIsDownloading(true);
    await downloadFileFromUrl({ url: imageUrl, fileName: 'image.jpg' });
    setIsDownloading(false);
  };

  return (
    <ActionIcon
      variant="transparent"
      color="gray.4"
      onClick={downloadImage}
      disabled={isDownloading}
      size="1.3rem"
    >
      <IconDownload />
    </ActionIcon>
  );
}
